








import { defineComponent } from "@vue/composition-api";

const Component = defineComponent({
  name: "MobileTemplate",
});

export default Component;
